__turbopack_context__.v({
  "header": "afbDHG_header",
  "scrolled": "afbDHG_scrolled",
});
